import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '@app/tw-shared/components';
import { DropdownOpenCloseService } from '@app/tw-shared/directives/dropdown-open-close/dropdown-open-close.service';
import { ListItemDirective } from '@app/tw-shared/directives/list-item/list-item.directive';
import { ListDirective } from '@app/tw-shared/directives/list/list.directive';
import { TranslateModule } from '@ngx-translate/core';
import { NavItemHelpService } from '../../services';
import { setGrow } from '../../../search/animations/grow.animation';
import { UserService } from '@app/user';
import { PopupService } from '@app/shared/popup';
import { CompanyAdminSupportPopupComponent } from '@app/shell/header/popup/company-admin-support-popup/company-admin-support-popup.component';

@Component({
    selector: 'app-nav-item-help-list',
    imports: [CommonModule, RouterModule, TranslateModule, IconComponent, ListDirective, ListItemDirective],
    templateUrl: './nav-item-help-list.component.html',
    styleUrl: './nav-item-help-list.component.scss',
    animations: [setGrow()]
})
export class NavItemHelpListComponent {
    @Input() open = false;
    private readonly navItemHelpService = inject(NavItemHelpService);
    private readonly userService = inject(UserService);
    private readonly dropdownOpenCloseService = inject(DropdownOpenCloseService);
    private readonly popupService = inject(PopupService);

    readonly listId = this.navItemHelpService.listId;

    get canShowCompanyAdminSupport() {
        return (
            (this.userService.user.company.selfRegistration.enabled && this.userService.user.company.selfRegistration.version !== 3) ||
            !this.userService.user.company.selfRegistration.enabled
        );
    }

    openCompanyAdminSupportPopup() {
        this.close();
        this.popupService.open(CompanyAdminSupportPopupComponent);
    }

    close() {
        this.dropdownOpenCloseService.openEvent$.next(false);
    }
}
